/* =========================================================
   SOLERZA CONFIGURATOR — v4
   Option Price Calculator (Shopify) + Hyper theme

   Kern van v4:
   • scroll-anker: de pagina schuift niet meer weg als de app
     hertekent of een stap open/dicht gaat (het "verspringen")
   • voortgang zit in de sticky balk onderin
   • prijs wordt automatisch gevonden en gelogd
   • animeren gebeurt alleen na een klik van de gebruiker,
     niet als de app zelf hertekent
   • de app blijft leidend op rules: dit script verbergt of
     toont nooit zelf stappen
   ========================================================= */
(function () {
  "use strict";

  var SLZ_DEBUG = false;

  /* Alleen op deze producten. Leeg = alle producten. */
  var ONLY_HANDLES = [];

  /* Vul hier de selector van de totaalprijs in als de automaat
     hem niet goed pakt (de console logt de kandidaten). */
  var PRICE_SELECTOR = "";

  var CFG = {
    root: ".product-custom-option",
    step: ".optionHolder",
    stepSkip: ".rule",
    optional: [".Referentie", ".referentie", ".opmerking"],
    cart: [".addToCartCustomButton", ".add-to-cart-container button", 'form[action*="/cart/add"] [type="submit"]'],
    cartWrap: ".add-to-cart-container",
    inputW: "#measurement-input-length",
    inputH: "#measurement-input-width",
    unitBtns: "#measurement-unit-mm, #measurement-unit-cm"
  };

  var COPY = {
    todo: "Nog kiezen",
    optional: "Optioneel",
    close: "Sluiten",
    edit: "Wijzig",
    choose: "Kies",
    next: "Volgende stap",
    nextLast: "Keuzes bevestigen",
    nextDone: "Afronden",
    saved: "Keuze bewaard",
    openAll: "Klap alles uit",
    closeAll: "Klap alles in",
    needChoice: "Maak eerst een keuze",
    needSize: "Vul eerst een geldige maat in",
    needInput: "Vul dit veld in om verder te gaan",
    progress: function (d, t) { return d + "/" + t; },
    status: function (n) { return n === 0 ? "Compleet" : "Nog " + n + (n === 1 ? " stap" : " stappen"); },
    ctaReady: "In winkelwagen",
    ctaBlocked: "Rond je keuzes af",
    showRows: "Prijsopbouw",
    hideRows: "Verberg opbouw",
    rangeErr: function (l, lo, hi, u) { return l + " moet tussen " + lo + " en " + hi + " " + u + " liggen"; },
    emptyErr: function (l) { return "Vul een " + l.toLowerCase() + " in"; }
  };

  var NONE = "__none__";
  var STEPS_KEY = "slz-steps-" + (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];

  /* ---- totaal aantal stappen uit de app-configuratie ----
     De app laadt haar opties via de proxy-bootstrap. Die URL pikken we
     uit de resource-timing en vragen we zelf op, zodat de voortgangsbalk
     vanaf de eerste seconde de volledige route kent. */
  var apiSteps = 0;

  function bootstrapUrl() {
    var hit = null;
    try {
      performance.getEntriesByType("resource").forEach(function (r) {
        if (/opc-express-proxy.*bootstrap/i.test(r.name)) hit = r.name;
      });
    } catch (e) {}
    return hit;
  }

  function countStepsIn(data) {
    var best = 0, seen = [];
    (function walk(o, depth) {
      if (!o || depth > 6 || typeof o !== "object") return;
      if (Array.isArray(o)) {
        if (o.length > 1 && o.length < 60 && o[0] && typeof o[0] === "object") {
          var k = Object.keys(o[0]).join(",").toLowerCase();
          /* een stap heeft een label/naam én een keuzetype of waarden */
          if (/label|name|title/.test(k) && /type|values|swatch|option/.test(k)) {
            seen.push(o.length + " × [" + Object.keys(o[0]).slice(0, 10).join(",") + "]");
            if (o.length > best) best = o.length;
          }
        }
        o.forEach(function (v) { walk(v, depth + 1); });
      } else {
        Object.keys(o).forEach(function (key) { walk(o[key], depth + 1); });
      }
    })(data, 0);
    if (SLZ_DEBUG) log("stap-arrays in de app-config:", seen);
    return best;
  }

  function loadApiSteps() {
    var url = bootstrapUrl();
    if (!url) { log("bootstrap-URL nog niet gezien"); return; }
    fetch(url, { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var n = countStepsIn(d);
        if (n >= 2 && n <= 40) {
          apiSteps = n;
          log("aantal stappen uit de app:", n);
          try { localStorage.setItem(STEPS_KEY, String(n)); } catch (e) {}
          render();
        } else {
          log("geen bruikbaar aantal stappen gevonden in de config");
        }
      })
      .catch(function (e) { log("bootstrap ophalen mislukt:", e.message); });
  }

  function rememberSteps(n) {
    try {
      var was = parseInt(localStorage.getItem(STEPS_KEY) || "0", 10) || 0;
      if (n > was && !apiSteps) localStorage.setItem(STEPS_KEY, String(n));
      /* stappen met één vaste, al aangevinkte keuze tellen niet mee */
      var api = apiSteps ? apiSteps - singleCount : 0;
      return Math.max(n, was - singleCount, api);
    } catch (e) { return Math.max(n, apiSteps - singleCount); }
  }
  /* start: eerste onafgeronde stap open */
  var state = {
    allOpen: false,
    wasComplete: false, pct: 0, confirmed: {}, openKey: null, touched: {}, expanded: false, ready: false, userAction: false, anchor: null };
  var observer = null, timer = null, busy = false;

  function log() { if (SLZ_DEBUG) console.log.apply(console, ["[solerza]"].concat([].slice.call(arguments))); }
  function txt(el) { return el ? (el.textContent || "").replace(/\s+/g, " ").trim() : ""; }
  function vis(el) { return el ? (el.innerText || "").replace(/\s+/g, " ").trim() : ""; }
  function clean(s) {
    var out = (s || "").replace(/\s*\*\s*$/, "").replace(/\s*\(\s*\+?\s*€\s*[\d.,]+\s*\)\s*$/, "").trim();
    return unshout(out);
  }

  /* Sommige opties staan in de app volledig in kapitalen. Woorden met
     cijfers of korte codes (RAL, TDBU) laten we staan. */
  var SMALL = ["op", "het", "de", "een", "en", "met", "in", "van", "voor", "tot", "bij", "aan", "of", "per", "als"];

  function unshout(s) {
    if (!s) return s;
    var words = s.split(/(\s+)/);
    var caps = 0;
    words.forEach(function (w) { if (/^[A-ZÀ-Ý]{2,}$/.test(w)) caps++; });
    if (!caps) return s;
    var wordIndex = -1;
    return words.map(function (w) {
      if (/^\s+$/.test(w)) return w;
      wordIndex++;
      if (/\d/.test(w)) return w;                       /* codes als RAL 9010 */
      if (!/^[A-ZÀ-Ý][A-ZÀ-Ý'’\-]*$/.test(w)) return w;  /* niet volledig kapitaal */
      var lower = w.toLowerCase();
      if (wordIndex > 0 && SMALL.indexOf(lower) !== -1) return lower;
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    }).join("");
  }
  function firstOf(list) {
    for (var i = 0; i < list.length; i++) {
      var el = document.querySelector(list[i]);
      if (el) return el;
    }
    return null;
  }

  /* ---------------- productcheck ---------------- */
  function handle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : "";
  }
  if (ONLY_HANDLES.length && ONLY_HANDLES.indexOf(handle()) === -1) {
    log("overgeslagen:", handle() || "geen product");
    return;
  }
  document.documentElement.classList.add("slz-on");

  /* ---------------- root & stappen ---------------- */
  function findRoot() {
    var r = document.querySelector(CFG.root);
    if (r) return r;
    var h = document.querySelector(CFG.step);
    return h ? h.parentElement : null;
  }
  var CONTROL = 'input[type="radio"],input[type="checkbox"],input[type="number"],input[type="text"],input[type="range"],select,textarea,.swatch-input,.option-type-swatch,.option-type-dropdown,.dropbtn,.option-type-button';
  function isStep(h) {
    if (!h.querySelector(CONTROL)) return false;
    /* .rule-blokken zijn normaal alleen regel-uitvoer, maar bij sommige
       producten zit er een echte keuze in (bv. kleur ladderband).
       Dan tonen we die tóch als stap. */
    if (h.matches(CFG.stepSkip)) {
      var live = h.querySelector(CONTROL);
      return !!(live && live.offsetParent !== null);
    }
    return true;
  }
  function holders() {
    var root = findRoot();
    if (!root) return [];
    /* Sommige producten leveren een keuzeveld zonder .optionHolder eromheen
       (bv. een losse dropdown). Dat blok promoveren we tot stap. */
    [].slice.call(root.children).forEach(function (c) {
      if (!c.classList || c.matches(CFG.step)) return;
      if (c.classList.contains("slz-progress") || c.classList.contains("slz-checkout") ||
          c.classList.contains("slz-toolbar") || c.classList.contains("slz-bar")) return;
      if (c.querySelector(CFG.step)) return;
      if (!c.querySelector(CONTROL)) return;
      c.classList.add("optionHolder", "slz-promoted");
    });
    return [].slice.call(root.querySelectorAll(CFG.step));
  }
  var singleCount = 0;
  function steps() {
    return holders().filter(function (h) {
      if (!isStep(h) || h.offsetParent === null) return false;
      /* één vaste, al aangevinkte keuze: blijft staan als afgeronde stap */
      h.classList.toggle("slz-fixed", isSingle(h));
      return true;
    });
  }
  function keyOf(h, i) {
    if (h.dataset.slzKey) return h.dataset.slzKey;
    var cls = (h.className || "").split(/\s+/).filter(function (c) {
      return c && c !== "optionHolder" && c.indexOf("slz-") !== 0 &&
        c !== "is-open" && c !== "is-done" && c !== "force-hide-step";
    });
    return cls.sort().join("_") || ("stap" + i);
  }
  function isOptional(h) { return CFG.optional.some(function (s) { return h.matches(s); }); }

  /* Eén keuzemogelijkheid die al aan staat: niets te kiezen, dus overslaan. */
  function isSingle(h) {
    if (isMeasure(h)) return false;
    var group = h.querySelector(".option-type-swatch");
    if (group) {
      var inputs = group.querySelectorAll('input[type="radio"], .swatch-input');
      return inputs.length === 1 && inputs[0].checked;
    }
    var sel = h.querySelector("select");
    if (sel) {
      var real = [].slice.call(sel.options).filter(function (o) { return o.value !== ""; });
      return real.length === 1 && !!sel.value;
    }
    var labels = h.querySelectorAll("label.button-label");
    if (labels.length === 1) {
      var inp = labels[0].htmlFor ? document.getElementById(labels[0].htmlFor) : null;
      return !inp || inp.checked;
    }
    var btns = h.querySelectorAll('.option-type-button button, [role="radio"], .btn-option');
    if (btns.length === 1) return true;
    return false;
  }
  function isMeasure(h) { return !!h.querySelector(CFG.inputW) || h.classList.contains("afmeting"); }

  /* ---------------- waarden ---------------- */
  function activeUnit() {
    var s = document.querySelector(".units-button.selected");
    return s ? txt(s).toLowerCase() : "mm";
  }
  function numOf(el) {
    if (!el) return null;
    var n = parseFloat(String(el.value).replace(",", "."));
    return isNaN(n) ? null : n;
  }
  function measureState() {
    var w = document.querySelector(CFG.inputW), h = document.querySelector(CFG.inputH);
    if (!w || !h) return { ok: false, summary: "", fields: [] };
    var unit = activeUnit(), fields = [], ok = true;
    [[w, "Breedte"], [h, "Hoogte"]].forEach(function (p) {
      var el = p[0], label = p[1], v = numOf(el);
      var lo = parseFloat(el.getAttribute("min")), hi = parseFloat(el.getAttribute("max"));
      var err = null;
      if (v === null) err = COPY.emptyErr(label);
      else if (!isNaN(lo) && (v < lo || v > hi)) err = COPY.rangeErr(label, lo, hi, unit);
      if (err) ok = false;
      fields.push({ el: el, label: label, err: err });
    });
    return { ok: ok, fields: fields, summary: ok ? numOf(w) + " × " + numOf(h) + " " + unit : "" };
  }
  function labelOf(input) {
    var c = [];
    if (input.id) { try { c.push(document.querySelector('label[for="' + CSS.escape(input.id) + '"]')); } catch (e) {} }
    c.push(input.closest("label"), input.nextElementSibling, input.parentElement);
    for (var i = 0; i < c.length; i++) {
      if (!c[i] || !c[i].querySelector) continue;
      var d = c[i].querySelector(".swatch-description-holder, .option-description");
      var s = clean(txt(d) || txt(c[i]));
      if (s) return s;
    }
    var a = input.getAttribute("data-name") || input.getAttribute("aria-label") || input.getAttribute("title");
    if (a) return clean(a);
    var v = (input.value || "").trim();
    if (!v || /^\d+$/.test(v) || /^[0-9a-f-]{6,}$/i.test(v)) return "Gekozen";
    return clean(v);
  }
  function readValue(h) {
    if (isMeasure(h)) return measureState().summary;
    var ch = h.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked, .swatch-input:checked');
    if (ch) return labelOf(ch);
    var sel = h.querySelector("select");
    if (sel) return sel.value ? clean(txt(sel.options[sel.selectedIndex])) : "";
    /* eigen dropdown van de app: de keuze staat in .selected-dropdown-view,
       anders in de knoptekst of in .opc-selected-name */
    var dd = h.querySelector(".option-type-dropdown");
    if (dd) {
      var picked = dd.querySelector(".selected-dropdown-view .dropdown-label, .selected-dropdown-view label");
      if (picked) return clean(txt(picked));
      var btnv = dd.querySelector(".dropbtn");
      if (btnv && btnv.value && !/selecteren/i.test(btnv.value)) return clean(btnv.value);
      var namev = h.querySelector(".opc-selected-name");
      if (namev && txt(namev) && !/selecteren/i.test(txt(namev))) return clean(txt(namev));
      return "";
    }
    /* knop-opties (geen swatch, geen radio): de app markeert de actieve
       knop met een class of aria-pressed */
    var btn = h.querySelector(
      'button.selected, button.active, button.is-active, button[aria-pressed="true"], ' +
      'button[aria-checked="true"], .option-type-button .selected, .option-type-button .active, ' +
      '[role="radio"][aria-checked="true"], .btn.selected, .btn.active'
    );
    if (btn) return clean(txt(btn));

    var t = h.querySelector('input[type="text"]:not([id*="measurement"]), textarea');
    if (t) return t.value.trim();
    return "";
  }

  /* ---------------- prijs ---------------- */
  var MONEY = /(?:€|EUR)\s?\d[\d.]*(?:,\d{2})?|\d[\d.]*,\d{2}/;
  var priceCache = null;

  /* De app rekent zelf en zet het totaal in één van deze elementen.
     Die hebben altijd voorrang op de "Vanaf"-prijs van het theme. */
  var PRICE_CANDIDATES = [
    ".addition-price-discount-price",                       /* prijs na korting */
    ".option-price-label .addition-price-value:not(.strike)",
    ".addition-price-value-holder",
    ".price-container .total-price",
    ".price-container",
    ".option-price-label"
  ];
  /* doorgestreepte prijs en kortingsbedrag apart, voor de balk */
  var WAS_SELECTOR = ".addition-price-option-discounted-price, .addition-price-value.strike";
  var SAVE_SELECTOR = ".addition-price-option-discount";

  function moneyIn(el) {
    if (!el) return "";
    var c = el.cloneNode(true);
    c.querySelectorAll('s, del, .strike, .addition-price-value.strike, .addition-price-option-discount, .addition-price-option-discounted-price, .compare-at, [class*="compare"], [class*="was"], [class*="old"], [class*="regular"], [class*="strike"]')
      .forEach(function (n) { n.remove(); });
    var t = txt(c) || txt(el);
    var all = t.match(/(?:€|EUR)\s?\d[\d.]*(?:,\d{2})?/g) || t.match(/\d[\d.]*,\d{2}/g);
    if (!all || !all.length) return "";
    /* eerste bedrag, zoals in het eerste concept (dat klopte) */
    var v = all[0].replace("EUR", "€").trim();
    return v.indexOf("€") === 0 ? v : "€ " + v;
  }

  function autoPriceEl() {
    var cands = [];
    [].slice.call(document.body.querySelectorAll("*")).forEach(function (el) {
      if (el.closest(".slz-bar")) return;
      if (el.children.length > 3) return;
      var t = (el.textContent || "").trim();
      if (t.length > 60 || !MONEY.test(t)) return;
      if (/vanaf|from|adviesprijs/i.test((el.parentElement && el.parentElement.textContent) || "")) return;
      if (el.closest("s, del, [class*=compare], [class*=strike]")) return;
      for (var i = 0; i < el.children.length; i++) {
        if (MONEY.test(el.children[i].textContent || "")) return;
      }
      cands.push({ el: el, size: parseFloat(getComputedStyle(el).fontSize) || 0, t: t, cls: el.className || el.id || el.tagName });
    });
    cands.sort(function (a, b) { return b.size - a.size; });
    if (SLZ_DEBUG && cands.length) {
      log("prijskandidaten:", cands.slice(0, 6).map(function (c) { return c.size + "px " + c.cls + " → " + c.t; }));
    }
    return cands.length ? cands[0].el : null;
  }

  function priceEl() {
    if (PRICE_SELECTOR) {
      var forced = document.querySelector(PRICE_SELECTOR);
      if (forced && moneyIn(forced)) return forced;
    }
    if (priceCache && document.contains(priceCache) && moneyIn(priceCache)) return priceCache;
    for (var k = 0; k < PRICE_CANDIDATES.length; k++) {
      var c0 = document.querySelector(PRICE_CANDIDATES[k]);
      if (c0 && moneyIn(c0)) {
        if (priceCache !== c0) log("prijs uit:", PRICE_CANDIDATES[k], "→", moneyIn(c0));
        priceCache = c0;
        return c0;
      }
    }
    var auto = autoPriceEl();
    if (auto) { priceCache = auto; log("prijs automatisch:", auto.className || auto.id, "→", moneyIn(auto)); }
    return auto;
  }

  function priceText() { return moneyIn(priceEl()); }

  function wasText() {
    var el = document.querySelector(WAS_SELECTOR);
    if (!el) return "";
    var t = txt(el);
    var m = t.match(/(?:€|EUR)\s?\d[\d.]*(?:,\d{2})?/);
    return m ? m[0].replace("EUR", "€") : "";
  }
  function saveText() {
    var el = document.querySelector(SAVE_SELECTOR);
    if (!el) return "";
    var t = txt(el);
    var m = t.match(/-?\s?(?:€|EUR)\s?\d[\d.]*(?:,\d{2})?/);
    return m ? m[0].replace("EUR", "€").replace(/\s+/g, "") : "";
  }

  function priceRows() {
    return steps().map(function (h) {
      var v = readValue(h);
      if (!v) return null;
      var extra = h.querySelector(".slz-opt.slz-sel .slz-opt-price");
      var title = txt(h.querySelector(".slz-step__title"));
      return {
        label: title,
        value: v,
        extra: extra ? txt(extra) : ""
      };
    }).filter(Boolean);
  }

  /* ---------------- kop + footer per stap ---------------- */
  function buildHeader(h, i, total) {
    if (h.querySelector(":scope > .slz-step__header")) return;

    var appHeader = h.querySelector(".stepHeader");
    var title = h.dataset.slzTitle ||
      txt(appHeader && appHeader.querySelector("h2")) ||
      txt(h.querySelector(".option-label")) || ("Stap " + (i + 1));
    title = title.replace(/^\s*[a-z]\s*[:.)]\s*/i, "");
    title = clean(title.replace(/^\s*\d+[.)\s]*/, "").replace(/^selecteer\s+/i, "")) || ("Stap " + (i + 1));
    title = title.charAt(0).toUpperCase() + title.slice(1);

    var header = document.createElement("div");
    header.className = "slz-step__header";
    header.setAttribute("role", "button");
    header.setAttribute("tabindex", "0");
    header.innerHTML =
      '<span class="slz-step__num"></span>' +
      '<span class="slz-step__titlewrap">' +
      '<span class="slz-step__title"></span>' +
      '<span class="slz-step__summary"></span>' +
      "</span>" +
      '<span class="slz-step__help"><button type="button" class="slz-q" aria-label="Uitleg">?</button></span>' +
      '<span class="slz-step__action"></span>';
    header.querySelector(".slz-step__title").textContent = title;
    h.insertBefore(header, h.firstChild);

    var help = h.querySelector(".tooltip-icon, .opc-modal-option-link");
    if (help && !help.closest(".slz-step__header")) {
      header.querySelector(".slz-step__help").appendChild(help);
    }

    var footer = document.createElement("div");
    footer.className = "slz-step__footer";
    footer.innerHTML = '<button type="button" class="slz-next"></button><span class="slz-next-hint"></span>';
    footer.querySelector(".slz-next").textContent = i === total - 1 ? COPY.nextLast : COPY.next;
    h.appendChild(footer);
  }

  /* Zichtbaarheid van de knoprijen. Dit gebeurt los van de opbouw, omdat
     de stap pas ná het decoreren als open wordt gemarkeerd. */
  function syncBtnRows() {
    [].slice.call(document.querySelectorAll(".slz-btnrow")).forEach(function (row) {
      var step = row.closest(CFG.step);
      var open = !step || !step.classList.contains("slz-step") ||
        step.classList.contains("is-open");
      var want = open ? "flex" : "none";
      if (row.style.getPropertyValue("display") !== want) {
        row.style.setProperty("display", want, "important");
      }
      [].slice.call(row.querySelectorAll(".slz-btncell")).forEach(function (c) {
        var w = open ? "flex" : "none";
        if (c.style.getPropertyValue("display") !== w) {
          c.style.setProperty("display", w, "important");
        }
      });
    });
  }

  /* Knop-opties: <label class="button-label"> bij een verborgen radio. */
  function decorateButtons(h) {
    var labels = h.querySelectorAll("label.button-label");
    if (!labels.length) return;
    /* De app zet elk label soms in een eigen omhulsel. De rij moet dan op
       het blok dat ze allemaal bevat, anders staat elke knop op een eigen
       regel en blijft het keuzerondje ernaast staan. */
    var mob = window.innerWidth < 750;
    var group = h.querySelector(".option-type-button") ||
      (labels.length > 1 ? labels[0].parentElement.parentElement : labels[0].parentElement);
    if (group && group.contains(labels[labels.length - 1])) {
      group.classList.add("slz-btnrow");
      group.style.setProperty("flex-wrap", "wrap", "important");
      group.style.setProperty("align-items", "stretch", "important");
      group.style.setProperty("gap", mob ? "8px" : "10px", "important");
      group.style.setProperty("margin", "0", "important");
      group.style.setProperty("padding", "0", "important");
      group.style.setProperty("list-style", "none", "important");
    }

    [].slice.call(labels).forEach(function (lb) {
      var input = lb.htmlFor ? document.getElementById(lb.htmlFor) : null;
      lb.classList.add("slz-btn");
      lb.classList.toggle("slz-btn-sel", !!(input && input.checked));
      /* Alles hier inline zetten, zodat het ook werkt zonder de CSS bij
         te werken. Het omhulsel per knop wordt een gewoon rij-element. */
      var cell = lb.parentElement && lb.parentElement !== group ? lb.parentElement : null;
      if (cell) {
        cell.classList.add("slz-btncell");
        cell.style.setProperty("flex", mob ? "1 1 calc(50% - 4px)" : "0 1 210px", "important");
        cell.style.setProperty("margin", "0", "important");
        cell.style.setProperty("padding", "0", "important");
        cell.style.setProperty("border", "0", "important");
        cell.style.setProperty("background", "transparent", "important");
        cell.style.setProperty("box-shadow", "none", "important");
        cell.style.setProperty("min-width", "0", "important");
        cell.style.setProperty("width", "auto", "important");
      }

      if (lb.style) {
        ["min-height", "height", "line-height", "font-size", "align-content"]
          .forEach(function (p) { lb.style.removeProperty(p); });
        lb.style.setProperty("flex", "1 1 100%", "important");
        lb.style.setProperty("width", "100%", "important");
        lb.style.setProperty("min-height", mob ? "46px" : "50px", "important");
        lb.style.setProperty("padding", mob ? "12px" : "13px 16px", "important");
        lb.style.setProperty("text-align", "center", "important");
        lb.style.setProperty("justify-content", "center", "important");
      }

      /* keuzerondje wegwerken zonder het onbruikbaar te maken */
      if (input && input.type === "radio") {
        input.style.setProperty("position", "absolute", "important");
        input.style.setProperty("width", "1px", "important");
        input.style.setProperty("height", "1px", "important");
        input.style.setProperty("opacity", "0", "important");
        input.style.setProperty("margin", "0", "important");
        input.style.setProperty("padding", "0", "important");
        input.style.setProperty("pointer-events", "none", "important");
        input.style.setProperty("appearance", "none", "important");
        input.style.setProperty("-webkit-appearance", "none", "important");
      }
    });

    [].slice.call(group ? group.querySelectorAll("br") : []).forEach(function (b) {
      b.style.setProperty("display", "none", "important");
    });
  }

  /* Het app-icoon verhuist onzichtbaar naar de kop; onze eigen ?-knop
     klikt hem aan. Zo bepaalt onze CSS de uitlijning volledig. */
  var HELP = new WeakMap();

  function mountHelp(h) {
    var head = h.querySelector(":scope > .slz-step__header");
    if (!head) return;
    var slot = head.querySelector(".slz-step__help");
    if (!slot) return;
    if (!slot.querySelector(".slz-q")) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "slz-q";
      btn.setAttribute("aria-label", "Uitleg");
      btn.textContent = "?";
      slot.insertBefore(btn, slot.firstChild);
    }
    /* eerder verplaatste iconen terugzetten waar de app ze verwacht */
    var moved = slot.querySelector(".tooltip-icon, .opc-modal-option-link");
    if (moved) {
      var home = h.querySelector(".option-list-frame, .instruction") || h;
      if (home !== slot) { try { home.appendChild(moved); } catch (e) {} }
    }
    var ic = HELP.get(h) ||
      h.querySelector(".tooltip-icon, .opc-modal-option-link") ||
      (h.dataset.slzHelpId ? document.getElementById(h.dataset.slzHelpId) : null);
    if (ic && document.contains(ic)) {
      HELP.set(h, ic);
      /* onzichtbaar maken via inline stijl, zodat hiervoor geen CSS nodig is */
      ic.classList.add("slz-icon-hidden");
      ic.style.cssText = "position:absolute;width:1px;height:1px;min-width:0;" +
        "min-height:0;padding:0;margin:-1px;opacity:0;overflow:hidden;" +
        "clip-path:inset(50%);pointer-events:none;";
    } else {
      ic = null;
      HELP.delete(h);
    }
    slot.classList.toggle("has-help", !!ic);
  }

  /* het i-icoon krijgt inline stijlen van de app: die strippen */
  function cleanIcon(h) {
    var ic = h.querySelector(".tooltip-icon");
    if (ic && ic.style) {
      ic.style.removeProperty("display");
      ic.style.removeProperty("margin-left");
      ic.style.removeProperty("vertical-align");
    }
    var svg = ic && ic.querySelector("svg");
    if (svg && svg.style) {
      svg.style.removeProperty("width");
      svg.style.removeProperty("height");
    }
  }

  function decorateOptions(h) {
    h.querySelectorAll(".option-type-swatch").forEach(function (group) {
      [].slice.call(group.children).forEach(function (opt) {
        if (!opt.querySelector) return;
        var input = opt.querySelector('input[type="radio"], input[type="checkbox"], .swatch-input');
        if (!input) return;
        opt.classList.add("slz-opt");
        opt.classList.toggle("slz-sel", !!input.checked);

        /* de app wrapt opties soms in rijen: zet het grid op de echte ouder */
        if (opt.parentElement) opt.parentElement.classList.add("slz-grid");

        /* inline width/height/aspect-ratio van de app weghalen zodat alle
           afbeeldingen exact hetzelfde formaat krijgen */
        var media = opt.querySelectorAll(".swatch, .swatch img, .swatch-input-holder");
        [].slice.call(media).forEach(function (m) {
          if (!m.style) return;
          m.style.removeProperty("width");
          m.style.removeProperty("height");
          m.style.removeProperty("min-width");
          m.style.removeProperty("min-height");
          m.style.removeProperty("max-width");
          m.style.removeProperty("max-height");
          m.style.removeProperty("aspect-ratio");
          m.style.removeProperty("background-size");
        });

        /* kleurstaal of afbeelding? */
        var sw = opt.querySelector(".swatch");
        if (sw) {
          var bi = "";
          try { bi = getComputedStyle(sw).backgroundImage; } catch (e) {}
          var hasImg = !!opt.querySelector(".swatch img") || (bi && bi !== "none");
          opt.classList.toggle("slz-opt--color", !hasImg);
        }
      });
    });
  }

  /* ---------------- meerprijs-badge ----------------
     Werkt zonder .slz-opt-wrapper: elke swatch-houder en knop-label krijgt
     zelf een badge. Bron: .priceLabel / .original-price / .tooltiptext /
     .priceholder / de optienaam / de app-data. */


  /* De app rendert de titel + het i-icoon in een eigen .optionHolder.step
     blok, direct boven het blok met de keuzes. Die twee koppelen we:
     titel naar onze stapkop, icoon ernaast, kopblok verbergen. */
  function pairAppHeaders() {
    var pendingTitle = "", pendingIcon = null;
    holders().forEach(function (h) {
      if (!h || !h.classList) return;
      /* Op sommige producten geeft de app het kopblok geen class "step";
         herken het dan aan een uitleg-icoon met een korte titel. */
      var isHeaderBlock = /(^|\s)step(\s|$)/i.test(h.className || "") && !isStep(h);
      if (!isHeaderBlock && !isStep(h) &&
          h.querySelector(".tooltip-icon, .opc-modal-option-link") &&
          txt(h).length < 60 &&
          !h.querySelector("input, select, textarea")) {
        isHeaderBlock = true;
      }
      if (isHeaderBlock) {
        h.classList.add("slz-appheader");
        var t = txt(h.querySelector(".stepHeader h2, h2, h3, .instruction-text")) || txt(h);
        if (t) {
          /* losse letter of nummering vooraan (zoals "B:") weghalen */
          t = t.replace(/^\s*[a-z]\s*[:.)]\s*/i, "");
          pendingTitle = clean(t.replace(/^\s*\d+[.)\s]*/, "").replace(/^selecteer\s+/i, ""));
          pendingTitle = pendingTitle.charAt(0).toUpperCase() + pendingTitle.slice(1);
          /* "Uitleg", "Meetinstructies" e.d. zijn de titel van het
             hulpvenster, niet van de stap: dan de optienaam gebruiken */
          if (/^(uitleg|info|informatie|meetinstructies?|instructies?|toelichting|hulp)$/i.test(pendingTitle)) {
            pendingTitle = "";
          }
        }
        var ic = h.querySelector(".tooltip-icon, .opc-modal-option-link");
        if (ic) pendingIcon = ic;
        return;
      }
      if (!isStep(h)) return;
      if (pendingTitle) h.dataset.slzTitle = pendingTitle;
      if (pendingIcon && !h.querySelector(".tooltip-icon, .opc-modal-option-link")) {
        HELP.set(h, pendingIcon);
        if (!pendingIcon.id) pendingIcon.id = "slz-help-" + Math.random().toString(36).slice(2, 8);
        h.dataset.slzHelpId = pendingIcon.id;
      }
      pendingTitle = ""; pendingIcon = null;
    });
  }

  function hideEmpties(h) {
    [].slice.call(h.children).forEach(function (c) {
      if (c.classList.contains("slz-step__header") || c.classList.contains("slz-step__footer")) return;
      if (c.querySelector("input,select,textarea,img,svg,button,a")) { c.classList.remove("slz-empty"); return; }
      if (!vis(c)) c.classList.add("slz-empty"); else c.classList.remove("slz-empty");
    });
  }

  /* ---------------- sticky balk ---------------- */
  function bar() {
    var el = document.querySelector(".slz-bar");
    if (el) return el;
    el = document.createElement("div");
    el.className = "slz-bar";
    el.innerHTML =
      '<div class="slz-bar__rows"></div>' +

      '<div class="slz-bar__main">' +
      '<button type="button" class="slz-bar__price">' +
      '<span class="slz-bar__now">' +
      '<span class="slz-bar__amount"></span>' +
      '<span class="slz-bar__was"></span>' +
      '<span class="slz-bar__save"></span>' +
      "</span>" +
      '<span class="slz-bar__toggle"></span>' +
      "</button>" +
      '<button type="button" class="slz-bar__cta"></button>' +
      "</div>";
    document.body.appendChild(el);

    el.querySelector(".slz-bar__price").addEventListener("click", function () {
      state.expanded = !state.expanded;
      el.classList.toggle("is-expanded", state.expanded);
      el.querySelector(".slz-bar__toggle").textContent = state.expanded ? COPY.hideRows : COPY.showRows;
      fillRows(el);
    });
    el.querySelector(".slz-bar__cta").addEventListener("click", function () {
      if (!el.classList.contains("is-ready")) {
        var miss = steps().filter(function (h) {
          return !isOptional(h) && !h.classList.contains("slz-fixed") &&
            (!readValue(h) || !state.confirmed[h.dataset.slzKey]);
        })[0];
        if (miss) { state.userAction = true; openStep(miss); }
        return;
      }
      var btn = firstOf(CFG.cart);
      if (btn) btn.click(); else log("add-to-cart knop niet gevonden");
    });
    return el;
  }

  function fillRows(b) {
    if (!state.expanded) return;
    b.querySelector(".slz-bar__rows").innerHTML = priceRows().map(function (r) {
      return '<div class="slz-bar__row"><span class="slz-bar__rowlabel">' + r.label +
        '</span><span class="slz-bar__rowval">' + r.value +
        (r.extra ? ' <b>' + r.extra + "</b>" : "") + "</span></div>";
    }).join("");
  }

  /* ---------------- render ---------------- */
  function render() {
    try {
      renderInner();
      syncBtnRows();
    } catch (e) {
      console.error("[solerza] render fout:", e && e.message, e);
      busy = false;
      var r = findRoot();
      if (observer && r) { try { observer.observe(r, { childList: true, subtree: true }); } catch (e2) {} }
    }
  }

  function renderInner() {
    var list = steps();
    if (!list.length) return;
    busy = true;
    if (observer) observer.disconnect();

    /* scroll-anker: het laatste element waar de gebruiker mee bezig was,
       anders de open stap, anders de container. Zo verspringt de pagina
       niet als de app door een rule stappen toevoegt of weghaalt. */
    var anchor = (state.anchor && document.contains(state.anchor) && state.anchor) ||
      document.querySelector(".slz-step.is-open > .slz-step__header") ||
      findRoot();
    var before = anchor ? anchor.getBoundingClientRect().top : null;
    var beforeCount = list.length;

    pairAppHeaders();
    list = steps();
    var keys = list.map(function (h, i) { return keyOf(h, i); });
    if (!state.openKey || (state.openKey !== NONE && keys.indexOf(state.openKey) === -1)) {
      /* Begin bij de eerste echte stap, ook als daar al iets voorgeselecteerd
         staat. Alleen stappen met één vaste keuze worden overgeslagen. */
      var f = list.filter(function (h) {
        return !isOptional(h) && !h.classList.contains("slz-fixed");
      })[0] || list.filter(function (h) { return !h.classList.contains("slz-fixed"); })[0] || list[0];
      state.openKey = keyOf(f, list.indexOf(f));
    }

    var required = 0, done = 0;

    list.forEach(function (h, i) {
      h.dataset.slzKey = keys[i];
      buildHeader(h, i, list.length);
      decorateOptions(h);
      decorateButtons(h);
      cleanIcon(h);
      mountHelp(h);
      hideEmpties(h);

      var value = readValue(h);
      var optional = isOptional(h);
      var key = h.dataset.slzKey || keys[i] || String(i);
      /* vaste stappen (één keuze) gelden meteen als bevestigd */
      if (h.classList.contains("slz-fixed") && value) state.confirmed[key] = true;
      /* een stap is pas "klaar" als de klant hem zelf heeft bevestigd;
         voorselecties van de app tellen dus niet mee in de balk */
      var ok = optional ? true : (!!value && !!state.confirmed[key]);
      /* vaste stappen (één keuze) en optionele stappen tellen niet mee:
         de balk laat alleen echte keuzes van de klant zien */
      if (!optional && !h.classList.contains("slz-fixed")) {
        required++;
        if (ok) done++;
      }

      /* alleen stappen die al een keuze hebben (of de huidige stap) mogen
         open geklikt worden; latere stappen zijn op slot */
      var reached = h.classList.contains("slz-fixed") ||
        (!!value && !!state.confirmed[key]) ||
        (isOptional(h) && !!state.confirmed[key]);
      h.classList.toggle("slz-reached", reached);

      var open = state.allOpen ? true : h.dataset.slzKey === state.openKey;
      var was = h.classList.contains("is-open");
      h.classList.add("slz-step");
      h.classList.toggle("is-open", open);
      h.classList.toggle("is-done", ok && !!value);
      h.classList.toggle("is-preset", !!value && !state.confirmed[key]);
      if (was !== open && state.userAction) animate(h, open);

      var head = h.querySelector(":scope > .slz-step__header");
      if (head) {
        /* titel uit het kopblok van de app kan later beschikbaar komen */
        if (h.dataset.slzTitle) {
          var tEl = head.querySelector(".slz-step__title");
          if (tEl && tEl.textContent !== h.dataset.slzTitle) tEl.textContent = h.dataset.slzTitle;
        }

        head.querySelector(".slz-step__num").textContent = ok && value ? "" : String(i + 1);
        head.querySelector(".slz-step__summary").textContent = value || (optional ? COPY.optional : COPY.todo);
        head.querySelector(".slz-step__action").textContent = open ? COPY.close : (value ? COPY.edit : COPY.choose);
      }
      var hint = h.querySelector(":scope > .slz-step__footer .slz-next-hint");
      if (hint) {
        var free = !h.querySelector('input[type="radio"], input[type="checkbox"], select, .swatch-item, label.button-label');
        hint.textContent = value ? COPY.saved
          : isMeasure(h) ? COPY.needSize
          : free ? COPY.needInput
          : COPY.needChoice;
      }
      var nextBtn = h.querySelector(":scope > .slz-step__footer .slz-next");
      if (nextBtn) nextBtn.classList.toggle("is-ready", !!value);


      if (isMeasure(h)) {
        measureState().fields.forEach(function (f) {
          var cont = f.el.closest(".input-unit-container") || f.el.parentElement;
          var wrap = cont.parentElement;
          var msg = wrap.querySelector(".slz-field-msg");
          if (!msg) {
            msg = document.createElement("p");
            msg.className = "slz-field-msg";
            wrap.insertBefore(msg, cont.nextSibling);
          }
          var show = !!f.err && !!state.touched.dims;
          cont.classList.toggle("slz-invalid", show);
          msg.textContent = show ? f.err : "";
          msg.classList.toggle("is-visible", show);
        });
      }
    });

    /* de huidige stap = eerste zonder eigen keuze; alles daarna op slot */
    var lockFrom = -1;
    list.forEach(function (h, i) {
      if (lockFrom === -1 && !h.classList.contains("slz-reached") && !isOptional(h)) lockFrom = i;
    });
    list.forEach(function (h, i) {
      h.classList.toggle("slz-locked", lockFrom !== -1 && i > lockFrom);
    });

    holders().forEach(function (h) {
      if (isStep(h)) return;
      h.classList.add("slz-note");
      h.classList.toggle("slz-empty", !vis(h));
    });

    /* alles in de root zonder zichtbare inhoud of zichtbaar element wegwerken */
    var rootNow = findRoot();
    if (rootNow) {
      [].slice.call(rootNow.children).forEach(function (c) {
        if (!c.classList || c.classList.contains("slz-bar")) return;
        if (c.classList.contains("slz-progress") || c.classList.contains("slz-checkout") ||
            c.classList.contains("slz-toolbar")) return;
        if (c.matches(CFG.step) && isStep(c)) return;
        if (vis(c)) { c.classList.remove("slz-empty"); return; }
        var live = c.querySelector("input,select,textarea,img");
        if (live && live.offsetParent !== null) { c.classList.remove("slz-empty"); return; }
        c.classList.add("slz-empty");
      });
    }

    /* balk */
    var b = bar();
    var left = required - done;
    var price = priceText();
    b.classList.toggle("is-ready", left === 0);
    b.classList.toggle("has-price", !!price);
    b.querySelector(".slz-bar__amount").textContent = price;
    var was = wasText(), save = saveText();
    b.querySelector(".slz-bar__was").textContent = was && was !== price ? was : "";
    b.querySelector(".slz-bar__save").textContent = save || "";
    b.querySelector(".slz-bar__toggle").textContent = state.expanded ? COPY.hideRows : COPY.showRows;
    /* voortgang als één balk die in stappen naar rechts loopt */
    /* voortgangsbalk bovenin de configurator */
    /* knop rechtsboven: alles uitklappen zodra de configuratie compleet is */
    var rootTop = findRoot();
    if (rootTop) {
      var toolbar = rootTop.querySelector(":scope > .slz-toolbar");
      if (!toolbar) {
        toolbar = document.createElement("div");
        toolbar.className = "slz-toolbar";
        toolbar.innerHTML = '<button type="button" class="slz-expand"></button>';
        toolbar.querySelector(".slz-expand").addEventListener("click", function () {
          state.userAction = true;
          state.allOpen = !state.allOpen;
          render();
        });
        rootTop.insertBefore(toolbar, rootTop.firstChild);
      }
      var eb = toolbar.querySelector(".slz-expand");
      if (eb) eb.textContent = state.allOpen ? COPY.closeAll : COPY.openAll;
      toolbar.classList.toggle("is-shown",
        document.documentElement.classList.contains("slz-complete"));
    }

    var rootP = findRoot();
    var prog = rootP && rootP.querySelector(":scope > .slz-progress");
    if (rootP && prog && rootP.lastElementChild !== prog) rootP.appendChild(prog);
    if (rootP && !prog) {
      prog = document.createElement("div");
      prog.className = "slz-progress";
      prog.innerHTML = '<div class="slz-progress__track"><div class="slz-progress__fill"></div></div>';
      rootP.appendChild(prog);
    }

    /* Vloeiende voortgang: start op een basiswaarde en loop alleen vooruit,
       zodat de balk niet terugspringt als de app nog stappen bijlaadt. */
    var fixedKeys = {};
    list.forEach(function (h) {
      if (h.classList.contains("slz-fixed") && h.dataset.slzKey) fixedKeys[h.dataset.slzKey] = true;
    });
    var fixedCount = list.filter(function (h) { return h.classList.contains("slz-fixed"); }).length;
    var total = Math.max(required, (apiSteps || 0) - fixedCount, 1);
    var BASE = 6;
    var raw = BASE + Math.round((done / total) * (100 - BASE));
    if (left === 0) raw = 100;
    if (raw < state.pct) raw = state.pct;
    state.pct = raw;
    var pf = prog && prog.querySelector(".slz-progress__fill");
    if (pf) pf.style.width = raw + "%";

    /* sticky balk: alleen zichtbaar zodra de klant zijn eerste keuze maakte */
    var started = Object.keys(state.confirmed).some(function (k) {
      return state.confirmed[k] && !fixedKeys[k];
    });
    b.classList.toggle("is-active", false); /* sticky balk uitgeschakeld */
    void started;

    /* alles klaar: eenmalige attentie op de winkelwagenknop */
    var wasComplete = document.documentElement.classList.contains("slz-complete");
    var isComplete = left === 0;
    if (isComplete !== wasComplete) {
      document.documentElement.classList.toggle("slz-complete", isComplete);
    }
    /* de flow is echt doorlopen zodra alles klaar is én er geen stap meer
       openstaat; daarna geldt heropenen als "wijzigen" -> Afronden tonen */
    if (isComplete && state.openKey === NONE) state.wasComplete = true;
    if (!isComplete) state.wasComplete = false;

    b.querySelector(".slz-bar__cta").textContent = left === 0 ? COPY.ctaReady : COPY.ctaBlocked;
    fillRows(b);

    placeCheckout();
    var root = findRoot();
    if (root) root.classList.add("slz-config");

    /* scroll terugzetten zodat niets wegspringt, ook als het aantal
       stappen door een rule veranderde */
    if (anchor && before !== null && document.contains(anchor)) {
      var after = anchor.getBoundingClientRect().top;
      var delta = after - before;
      if (Math.abs(delta) > 0.5) {
        var prev = window.pageYOffset;
        window.scrollTo(0, prev + delta);
      }
    }
    if (SLZ_DEBUG && beforeCount !== steps().length) {
      log("stappen aangepast door rule:", beforeCount, "->", steps().length);
    }

    state.userAction = false;
    lastSig = signature();
    busy = false;
    if (observer && root) observer.observe(root, { childList: true, subtree: true });
  }

  function animate(h, opening) {
    var header = h.querySelector(":scope > .slz-step__header");
    if (!header) return;
    var closed = header.offsetHeight;
    if (h._slzAnim) clearTimeout(h._slzAnim);
    h.style.overflow = "hidden";
    h.style.transition = "max-height .3s cubic-bezier(.22,.7,.25,1)";
    h.style.maxHeight = (opening ? closed : h.scrollHeight) + "px";
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        h.style.maxHeight = (opening ? h.scrollHeight : closed) + "px";
      });
    });
    h._slzAnim = setTimeout(function () {
      h.style.maxHeight = "";
      h.style.transition = "";
      h.style.overflow = "";
    }, 340);
  }

  /* Vingerafdruk van de configurator. Verandert die niet, dan hoeft er
     niets hertekend te worden — en verspringt er dus ook niets. */
  function signature() {
    var list = steps();
    return list.map(function (h, i) {
      return keyOf(h, i) + "=" + readValue(h) + (h.classList.contains("is-open") ? "*" : "");
    }).join("|") + "#" + state.openKey + "#" + priceText() + "#" + wasText() + "#" + state.expanded;
  }
  var lastSig = "";

  /* Het buy-blok van het theme laten we staan (verplaatsen wordt door
     theme/app teruggedraaid). We verbergen het en zetten zelf een groene
     knop in een navy paneel dat aansluit op het prijspaneel. Die knop
     klikt het echte formulier aan, dus alle validatie blijft werken. */
  function placeCheckout() {
    var price = document.querySelector(".option-price-container");
    if (!price) return;
    var realBtn = firstOf(CFG.cart);
    var root = findRoot();
    /* elke variant verbergen: desktop, mobiel en eventuele sticky van het theme */
    CFG.cart.forEach(function (sel) {
      [].slice.call(document.querySelectorAll(sel)).forEach(function (btn) {
        if (btn.closest(".slz-checkout")) return;
        var block = btn.closest(".product__block--buy_buttons") ||
          btn.closest(".product-form__buttons") ||
          btn.closest(".add-to-cart-container") ||
          btn.parentElement;
        /* nooit een container verbergen waar de configurator zelf in zit */
        if (block && root && block.contains(root)) block = btn.parentElement;
        if (block && root && block.contains(root)) block = btn;
        (block || btn).classList.add("slz-hidden-buy");
      });
    });

    var anchor = price.closest(".shopify-app-block, .product__block") || price;
    var panel = document.querySelector(".slz-checkout");
    if (!panel) {
      panel = document.createElement("div");
      panel.className = "slz-checkout";
      panel.innerHTML = '<button type="button" class="slz-cta"></button>';
      panel.querySelector(".slz-cta").addEventListener("click", function () {
        var self = this;
        if (self.dataset.busy) return;
        self.dataset.busy = "1";
        var oldLabel = self.textContent;
        self.textContent = "";
        /* de knop wordt wit bij hover: tijdens het laden de groene vulling
           vasthouden, anders is een wit cirkeltje onzichtbaar */
        self.style.setProperty("background", "#0B8C6A", "important");
        self.style.setProperty("border-color", "#0B8C6A", "important");
        self.style.setProperty("cursor", "wait", "important");
        var sp = document.createElement("span");
        sp.setAttribute("style",
          "display:inline-block!important;width:20px!important;height:20px!important;" +
          "border:2.5px solid rgba(255,255,255,.35)!important;border-top-color:#fff!important;" +
          "border-radius:50%!important;box-sizing:border-box!important;vertical-align:middle!important;" +
          "animation:slz-spin .7s linear infinite!important");
        self.appendChild(sp);
        if (!document.getElementById("slz-spin-kf")) {
          var kf = document.createElement("style");
          kf.id = "slz-spin-kf";
          kf.textContent = "@keyframes slz-spin{to{transform:rotate(360deg)}}";
          document.head.appendChild(kf);
        }
        var stop = function () {
          delete self.dataset.busy;
          ["background", "border-color", "cursor"].forEach(function (p) {
            self.style.removeProperty(p);
          });
          if (sp.parentNode) sp.remove();
          self.textContent = oldLabel;
        };
        /* laten draaien tot de winkelwagen opent of de pagina verandert */
        setTimeout(stop, 6000);
        ["cart:refresh", "cart:open", "cart-drawer:open", "on:cart-drawer:opened"]
          .forEach(function (ev) {
            document.addEventListener(ev, stop, { once: true });
          });
        var b = firstOf(CFG.cart);
        if (b) b.click(); else log("winkelwagenknop niet gevonden");
      });
    }
    if (anchor.nextElementSibling !== panel) {
      try { anchor.parentNode.insertBefore(panel, anchor.nextSibling); } catch (e) {}
    }
    var label = realBtn ? txt(realBtn) : "";
    var cta = panel.querySelector(".slz-cta");
    if (cta && !cta.dataset.busy) cta.textContent = label || "In winkelwagen";
  }

  /* Zodra het prijspaneel of de winkelwagenknop in beeld komt, verdwijnt
     de sticky balk: geen twee prijzen en twee CTA's tegelijk. */
  function watchCheckout() {
    if (!("IntersectionObserver" in window)) return;
    var targets = [];
    var p = document.querySelector(".option-price-container");
    var c = firstOf(CFG.cart);
    if (p) targets.push(p);
    if (c) targets.push(c);
    if (!targets.length) { setTimeout(watchCheckout, 1200); return; }
    var io = new IntersectionObserver(function (entries) {
      var visible = entries.some(function (e) { return e.isIntersecting; });
      var b = document.querySelector(".slz-bar");
      if (b) b.classList.toggle("is-hidden", visible);
    }, { rootMargin: "0px 0px -60px 0px", threshold: 0.15 });
    targets.forEach(function (t) { io.observe(t); });
  }

  function schedule() {
    if (busy) return;
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (signature() === lastSig) return;
      render();
    }, 260);
  }

  function openStep(h) {
    state.openKey = h.dataset.slzKey || keyOf(h, steps().indexOf(h));
    render();
    /* De open stap netjes in beeld centreren, pas als hij volledig is
       opengeklapt. Past hij niet in het venster, dan lijnt de kop uit
       met 120px lucht erboven. */
    setTimeout(function () {
      if (!document.contains(h)) return;
      var r = h.getBoundingClientRect();
      var barH = 110;                        /* sticky prijsbalk */
      var topSafe = 96;                      /* sticky menu/USP-balk */
      var view = window.innerHeight - barH - topSafe;
      var top;
      if (r.height < view) {
        top = r.top + window.pageYOffset - topSafe - (view - r.height) / 2;
      } else {
        top = r.top + window.pageYOffset - topSafe - 24;
      }
      window.scrollTo({ top: Math.max(0, Math.round(top)), behavior: "smooth" });
    }, 400);
  }

  /* ---------------- events ---------------- */
  /* slz-cta-refresh: het theme hertekent de knop na de cart-drawer;
     dan onze klasse opnieuw zetten zodat de stijl weer pakt */
  function refreshCta() {
    var cta = document.querySelector(".slz-checkout .slz-cta");
    if (!cta) return;
    cta.classList.remove("slz-cta");
    void cta.offsetWidth;
    cta.classList.add("slz-cta");
  }
  ["pageshow", "focus"].forEach(function (ev) {
    window.addEventListener(ev, function () { setTimeout(refreshCta, 60); });
  });
  document.addEventListener("cart:refresh", function () { setTimeout(refreshCta, 60); });

  /* De app rekent even; de knop moet meteen laten zien dat hij aan staat. */
  document.addEventListener("click", function (e) {
    var lb = e.target.closest && e.target.closest("label.slz-btn, .swatch-input-holder label");
    if (lb) {
      var row = lb.closest(".slz-btnrow, .option-type-swatch, .option-type-button");
      if (row) {
        [].slice.call(row.querySelectorAll("label.slz-btn")).forEach(function (o) {
          o.classList.toggle("slz-btn-sel", o === lb);
        });
        [].slice.call(row.querySelectorAll(".swatch-input-holder")).forEach(function (o) {
          o.classList.toggle("slz-sel", o.contains(lb));
        });
      }
    }
  }, true);

  document.addEventListener("click", function (e) {
    var q = e.target.closest && e.target.closest(".slz-q");
    if (q) {
      e.preventDefault();
      e.stopPropagation();
      var qh = q.closest(CFG.step);
      var ic2 = (qh && HELP.get(qh)) ||
        (qh && qh.dataset.slzHelpId ? document.getElementById(qh.dataset.slzHelpId) : null) ||
        (qh && qh.querySelector(".tooltip-icon, .opc-modal-option-link"));
      if (!ic2) return;
      /* de app hangt zijn listener soms op de svg of een kind daarvan:
         van binnen naar buiten proberen */
      var targets = [].slice.call(ic2.querySelectorAll("svg, path, a, button"));
      targets.push(ic2);
      for (var ti = 0; ti < targets.length; ti++) {
        try { targets[ti].dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true, view: window })); } catch (err) {}
      }
      return;
    }
    var near = e.target.closest && e.target.closest(".slz-step__header, .slz-opt, .slz-step__footer");
    if (near) {
      var st = near.closest(CFG.step);
      state.anchor = (st && st.querySelector(":scope > .slz-step__header")) || near;
    }
    if (e.target.closest(".tooltip-icon, .opc-modal-option-link")) return;

    var header = e.target.closest(".slz-step__header");
    if (header) {
      var h = header.closest(CFG.step);
      /* nog niet bereikte stap: niet openen */
      if (!h.classList.contains("is-open") && h.classList.contains("slz-locked")) return;
      /* vaste stap met één keuze: alleen de ?-knop is bruikbaar */
      if (h.classList.contains("slz-fixed")) return;
      state.userAction = true;
      state.allOpen = false;
      state.openKey = h.classList.contains("is-open") ? NONE : h.dataset.slzKey;
      render();
      return;
    }
    var next = e.target.closest(".slz-next");
    if (next) {
      var holder = next.closest(CFG.step);
      state.userAction = true;
      if (holder.dataset.slzKey) state.confirmed[holder.dataset.slzKey] = true;
      if (!readValue(holder)) {
        state.touched.dims = true;
        render();
        return;
      }
      var list = steps(), i = list.indexOf(holder);
      /* gewoon naar de volgende stap; alleen stappen met één enkele optie
         (niets te kiezen) worden overgeslagen */
      var target = null;
      for (var n = i + 1; n < list.length; n++) {
        if (list[n].classList.contains("slz-fixed")) continue;
        target = list[n];
        break;
      }
      if (!target) { state.openKey = NONE; render(); return; }
      openStep(target);
    }
  });

  /* klik ergens in de kaart = die optie kiezen */
  document.addEventListener("click", function (e) {
    var card = e.target.closest(".slz-opt");
    if (!card) return;
    if (e.target.closest("input, label, a, .tooltip-icon")) return;
    var input = card.querySelector('input[type="radio"], input[type="checkbox"], .swatch-input');
    if (!input || input.checked) return;
    var lbl = input.id ? card.querySelector('label[for="' + input.id + '"]') : card.querySelector("label");
    if (lbl) lbl.click(); else input.click();
  }, true);

  /* De app rekent even; de knop laat meteen zien dat hij aan staat. */
  document.addEventListener("click", function (e) {
    var lb = e.target.closest && e.target.closest("label.slz-btn");
    if (!lb) return;
    var row = lb.closest(".slz-btnrow, .option-type-button") || lb.closest(CFG.step);
    if (!row) return;
    [].slice.call(row.querySelectorAll("label.slz-btn")).forEach(function (o) {
      o.classList.toggle("slz-btn-sel", o === lb);
    });
  }, true);

  /* knop-opties: klik telt als keuze */
  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest('button, [role="radio"], .btn-option, label.button-label');
    if (!b) return;
    if (b.closest(".slz-bar, .slz-step__header, .slz-step__footer")) return;
    var st = b.closest(CFG.step);
    if (!st) return;
    if (st.dataset.slzKey) state.confirmed[st.dataset.slzKey] = true;
    setTimeout(schedule, 260);
  }, true);

  document.addEventListener("keydown", function (e) {
    if ((e.key === "Enter" || e.key === " ") && e.target.classList &&
      e.target.classList.contains("slz-step__header")) {
      e.preventDefault();
      e.target.click();
    }
  });

  document.addEventListener("change", function (e) {
    if (!e.target.closest || !e.target.closest(CFG.step)) return;
    var group = e.target.closest(".option-type-swatch");
    if (group) {
      [].slice.call(group.children).forEach(function (opt) {
        var inp = opt.querySelector && opt.querySelector('input[type="radio"], input[type="checkbox"], .swatch-input');
        if (inp) opt.classList.toggle("slz-sel", inp.checked);
      });
    }
    if (e.target.id && e.target.id.indexOf("measurement-input") === 0) state.touched.dims = true;
    var stepEl = e.target.closest(CFG.step);
    if (stepEl && stepEl.dataset.slzKey) state.confirmed[stepEl.dataset.slzKey] = true;
    schedule();
  }, true);

  document.addEventListener("input", function (e) {
    var el = e.target;
    if (!el.id || el.id.indexOf("measurement-input") !== 0) return;
    var cont = el.closest(".input-unit-container");
    if (cont) cont.classList.remove("slz-invalid");
    var msg = cont && cont.parentElement.querySelector(".slz-field-msg");
    if (msg) msg.classList.remove("is-visible");
  }, true);

  document.addEventListener("focusin", function (e) {
    var st = e.target.closest && e.target.closest(CFG.step);
    if (st) state.anchor = st.querySelector(":scope > .slz-step__header") || st;
  }, true);

  document.addEventListener("focusout", function (e) {
    if (e.target.id && e.target.id.indexOf("measurement-input") === 0) {
      state.touched.dims = true;
      schedule();
    }
  }, true);

  document.addEventListener("click", function (e) {
    if (e.target.closest && e.target.closest(CFG.unitBtns)) setTimeout(schedule, 240);
  }, true);

  /* ---------------- start ---------------- */
  function start() {
    if (state.ready) return true;
    var root = findRoot();
    if (!root || !steps().length) return false;
    state.ready = true;
    if (!window.__slzBtnBeat) {
      window.__slzBtnBeat = setInterval(syncBtnRows, 180);
    }
    root.classList.add("slz-config");
    placeCheckout();
    watchCheckout();
    observer = new MutationObserver(function () { schedule(); });
    render();
    setTimeout(loadApiSteps, 400);
    log("GESTART", {
      stappen: steps().length,
      tekstblokken: holders().length - steps().length,
      prijs: priceText() || "NIET GEVONDEN",
      cartKnop: !!firstOf(CFG.cart),
      iIconen: document.querySelectorAll(".tooltip-icon, .opc-modal-option-link").length
    });
    return true;
  }

  var tries = 0;
  var poll = setInterval(function () {
    if (start() || ++tries > 60) {
      clearInterval(poll);
      if (!state.ready) {
        console.warn("[solerza] niet gestart. optionHolders=" +
          document.querySelectorAll(CFG.step).length + ", root=" +
          (findRoot() ? findRoot().className : "geen"));
      }
    }
  }, 500);

  new MutationObserver(function () { if (!state.ready) start(); })
    .observe(document.documentElement, { childList: true, subtree: true });

  /* ---------------- vanaf-prijs zonder maat ----------------
     Zolang er geen maat is ingevuld rekent de app €0,00. Dan tonen we
     de vanaf-prijs van het product zelf (uit de themekop) als "Vanaf …".
     Zodra er een maat staat, neemt de app het weer over. */
  /* De vanaf-prijs komt uit de productdata van Shopify zelf; de themekop
     is alleen een terugval. */
  var shopFrom = "";
  var fromReady = false;
  try {
    var ck = sessionStorage.getItem("slz_from_" + location.pathname);
    if (ck) { shopFrom = ck; fromReady = true; }
  } catch (e) {}
  if (!fromReady) document.documentElement.classList.add("slz-priceload");

  (function () {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    fetch("/products/" + m[1] + ".js", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        var cents = p.price_min || p.price ||
          Math.min.apply(null, (p.variants || []).map(function (v) { return v.price; }));
        if (!cents || !isFinite(cents)) return;
        shopFrom = "€" + (cents / 100).toFixed(2).replace(".", ",");
        try { sessionStorage.setItem("slz_from_" + location.pathname, shopFrom); } catch (er) {}
        log("vanaf-prijs uit productdata:", shopFrom);
      })
      .catch(function () {})
      .then(function () {
        fromReady = true;
        fromStyles();
        paintFrom();
      });
    /* niet eindeloos wachten */
    setTimeout(function () {
      fromReady = true;
      document.documentElement.classList.remove("slz-priceload");
    }, 2500);
  })();

  function themePrice() {
    if (shopFrom) return shopFrom;
    var sels = [
      ".price__container .price-item--regular",
      ".price-item--regular", ".price__regular .price-item",
      ".product__price", ".product-price", "[data-product-price]",
      ".price .money", ".price"
    ];
    for (var i = 0; i < sels.length; i++) {
      var el = document.querySelector(sels[i]);
      if (!el || el.closest(".option-price-container")) continue;
      var t = (el.textContent || "").replace(/\s+/g, " ").trim();
      var mm = t.match(/€\s?\d[\d.]*(?:,\d{2})?/);
      if (mm && !/^€\s?0[,.]00$/.test(mm[0])) return mm[0].replace(/\s/g, "");
    }
    return "";
  }

  function dimsFilled() {
    var a = document.querySelector(CFG.inputW);
    var b = document.querySelector(CFG.inputH);
    if (!a || !b) return true;
    return a.value !== "" && b.value !== "";
  }

  function fromStyles() {
    if (document.getElementById("slz-from-css")) return;
    var s = document.createElement("style");
    s.id = "slz-from-css";
    s.textContent = [
      "html.slz-on .option-price-container .addition-price-holder{min-height:44px!important;display:flex!important;align-items:center!important;justify-content:flex-end!important}",
      "html.slz-from-on .option-price-container .addition-price-holder > *:not(.slz-from){display:none!important}",
      ".slz-from{display:none}",
      "html.slz-priceload .option-price-container .addition-price-holder > *{visibility:hidden!important}",
      "html.slz-from-on .slz-from{display:flex!important;align-items:baseline;gap:9px}",
      ".slz-from__lbl{font-size:14px;font-weight:600;color:rgba(255,255,255,.72)}",
      ".slz-from__val{font-size:32px;font-weight:800;letter-spacing:-.02em;color:#fff;font-variant-numeric:tabular-nums}",
      "@media (max-width:749px){html.slz-on .option-price-container .addition-price-holder{min-height:40px!important;justify-content:center!important}.slz-from__val{font-size:27px}}"
    ].join("");
    document.head.appendChild(s);
  }

  function paintFrom() {
    var box = document.querySelector(".option-price-container .addition-price-holder");
    if (!box) return;
    var show = !dimsFilled();
    var txt = show ? themePrice() : "";
    var el = box.querySelector(".slz-from");
    if (show && txt) {
      if (!el) {
        el = document.createElement("div");
        el.className = "slz-from";
        box.appendChild(el);
      }
      var want = '<span class="slz-from__lbl">Vanaf</span><span class="slz-from__val">' + txt + "</span>";
      if (el.innerHTML !== want) el.innerHTML = want;
    } else if (el) {
      el.remove();
    }
    document.documentElement.classList.toggle("slz-from-on", !!(show && txt));
    if (txt || !show) document.documentElement.classList.remove("slz-priceload");
  }

  fromStyles();
  var fastTimer = setInterval(function () {
    fromStyles();
    paintFrom();
    if (state.ready) clearInterval(fastTimer);
  }, 60);

  var fromObs = null;
  setInterval(function () {
    if (!state.ready) return;
    fromStyles();
    paintFrom();
    if (!fromObs) {
      var box = document.querySelector(".option-price-container");
      if (box) {
        fromObs = new MutationObserver(function () { paintFrom(); });
        fromObs.observe(box, { childList: true, subtree: true, characterData: true });
      }
    }
  }, 300);

  window.SolerzaConfig = {
    CFG: CFG, render: render, state: state, steps: steps, holders: holders,
    priceEl: priceEl, priceText: priceText,
    setPrice: function (sel) { PRICE_SELECTOR = sel; priceCache = null; render(); return priceText(); }
  };
})();
